<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">Lead search for {{ title }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line="single-line"
          hide-details="hide-details"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="id"
        :items="leads"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer" @click="props.expanded = !props.expanded">
            <td class="text-xs-left">{{ props.item.id }}</td>
            <td class="text-xs-left">{{ props.item.firstName }}</td>
            <td class="text-xs-left">{{ props.item.businessName }}</td>
            <td class="text-xs-left">{{ props.item.phoneNumber | USPhoneNumber }}</td>
            <td class="text-xs-left">{{ props.item.assignedToUser.fullName }}</td>
            <td class="text-xs-left">{{ $moment(props.item.dueDate).format("MM/DD h:m a") }}</td>
            <td class="text-xs-left">{{ props.item.statusDetail.selector }}</td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card>
            <v-card-text>
              <v-card class="elevation-15" dark color="#1B1B1D">
                <v-container grid-list-md>
                  <v-layout row="row" wrap="wrap">
                    <v-flex xs12 sm6>
                      <h3 class="font-weight-bold mb-2" style="color: #21C593;">Lead</h3>
                      <div class="font-weight-bold">{{ $t("labels.createdAt") }}</div>
                      <div>
                        {{ $moment(props.item.createdAt).format("MM/DD/YYYY h:m a") }}
                      </div>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.businessName") }}</div>
                      <div>{{ props.item.businessName }}</div>

                      <h3 class="font-weight-bold mb-2 mt-3" style="color: #21C593;">Address</h3>
                      <div>
                        <span class="font-weight-bold mt-1 "
                          >{{ $t("labels.streetAddress") }}:
                        </span>
                        <span>{{ props.item.businessName }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.city") }}: </span>
                        <span>{{ props.item.city }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.state") }}: </span>

                        <span>{{ props.item.state }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.zipCode") }}: </span>

                        <span>{{ props.item.zipcode }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <h3 class="font-weight-bold mb-2" style="color: #21C593;">Contact</h3>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.name") }}: </span>

                        <span>{{ props.item.firstName }} {{ props.item.lastName }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.phoneNumber") }}: </span>

                        <span>{{ props.item.phoneNumber | USPhoneNumber }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.emailAddress") }}: </span>

                        <span>{{ props.item.email }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold"
                          >{{ $t("labels.locationCount") }}:
                        </span>

                        <span>{{ props.item.locationCount }}</span>
                      </div>
                      <h3 class="font-weight-bold mb-2 mt-3" style="color: #21C593;">Note</h3>
                      <div>{{ props.item.notes }}</div>
                    </v-flex>
                    <v-layout row="row" wrap="wrap">
                      <v-btn color="info" @click="gotoPage(props.item)">Go to page</v-btn>
                      <v-btn color="info" flat="flat" @click="gotoPageNewTab(props.item)">
                        <v-icon left="left">open_in_new </v-icon>Open in new tab</v-btn
                      >
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card>
            </v-card-text>
          </v-card>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import leadService from "../service.js";
import { mapGetters } from "vuex";

export default {
  props: ["leads", "loading", "title"],
  data() {
    return {
      headers: [
        {
          text: this.$t("labels.leadNumber"),
          value: "id",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.name"),
          value: "firstName",
          sortable: true
        },
        {
          text: this.$t("labels.businessName"),
          value: "businessName",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.assignedTo"),
          value: "assignedToUser.fullName",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.followOn"),
          value: "dueDate",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.status"),
          value: "statusDetail.selector",
          sortable: true,
          width: "10%"
        }
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      }
    };
  },
  methods: {
    gotoPageNewTab(data) {
      let routeData = this.$router.resolve({ path: `/leads/profile/${data.id}` });
      window.open(routeData.href, "_blank");
    },
    removeLead(lead) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return leadService
            .delete(lead.id)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "Lead has been deleted.", "success");
                this.$Progress.finish();
                this.getList();
              }
            })
            .catch(error => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    },
    gotoPage(data) {
      this.$router.push({ path: `/leads/profile/${data.id}` });
    }
  }
};
</script>
